module.exports = __webpack_public_path__ + "img/kaist_gallery13.985bd77b.jpg";